import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import rs from "./locales/rs/translation.json"
import me from "./locales/me/translation.json"
import mk from "./locales/mk/translation.json"

const resources = {
    rs: {
      translation: rs
    },
    me: {
      translation: me
    },
    mk: {
      translation: mk
    },
   
  }


  i18n
  .use(initReactI18next)
  .init({
    resources,
  });

export default i18n;